<template>
  <div class="survey-questions-component container-fluid container-lg">
    <question-counter :current="question" :total="_questions.length" />

    <div class="py-7">
      <template v-if="Array.isArray(_question)">
        <survey-question
          v-for="(q, index) in _question"
          v-model="answers[q.id]"
          class="mb-7"
          :key="index"
          :question="q"
        />
      </template>
      <survey-question
        v-else
        v-model="answers[_question.id]"
        :key="_question.id"
        :question="_question"
      />

      <div v-if="error" class="error mt-5">
        <bp-icon
          class="text-negative-500"
          icon="fa-solid fa-exclamation-circle"
        />
        <span class="text-negative-600">
          Por favor, responda a pergunta para poder avançar
        </span>
      </div>

      <div
        class="d-flex flex-column flex-lg-row justify-content-lg-end gap-5 mt-7"
      >
        <bp-button
          v-if="question > 0"
          label="Voltar"
          color="neutral"
          variant="filled-1"
          icon="fa-light fa-angle-left"
          class="order-1 order-lg-0"
          @click="previous"
        />
        <bp-button
          trailingIcon="fa-light fa-angle-right"
          :loading="loading"
          :label="isLast ? 'Concluir' : 'Próximo'"
          @click="next"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import QuestionCounter from "./QuestionCounter.vue";
import SurveyQuestion from "./SurveyQuestion.vue";

export default {
  components: {
    SurveyQuestion,
    QuestionCounter
  },
  data() {
    return {
      question: 0,
      error: false,
      answers: {},
      loading: false
    };
  },
  computed: {
    ...mapState("user", ["survey"]),
    _questions() {
      if (!this.survey) return [];
      const groups = this.survey.reduce((acc, item, index) => {
        const group = item.group_code;
        if (group) {
          if (acc[group]) acc[group]["questions"].push(item);
          else acc[group] = { index, questions: [item] };
        }

        return acc;
      }, {});

      const questions = this.survey
        .map(i => {
          return i.group_code ? null : i;
        })
        .filter(i => !!i);

      Object.values(groups).forEach(value => {
        questions.splice(value.index, 0, value.questions);
      });

      return questions;
    },
    _question() {
      if (!this._questions) return {};
      return this._questions[this.question] || {};
    },
    isLast() {
      if (!this._question) return false;

      if (Array.isArray(this._question))
        return this._question[this._question.length - 1].is_last_question;
      return this._question.is_last_question;
    }
  },
  methods: {
    next() {
      if (Array.isArray(this._question)) {
        if (this._question.find(q => !this.hasAnswer(q.id))) {
          this.error = true;
          return;
        }
      } else if (!this.hasAnswer(this._question.id)) {
        this.error = true;
        return;
      }

      this.error = false;
      if (this.isLast) return this.submit();
      this.question++;
    },
    previous() {
      this.question--;
    },
    hasAnswer(id) {
      return !!this.answers[id];
    },
    submit() {
      const data = {
        survey_answers: Object.entries(this.answers).map(
          ([question_id, answer]) => ({
            question_id,
            answer
          })
        )
      };
      this.loading = true;
      this.$store
        .dispatch("user/submitSurvey", data)
        .then(() => {
          this.$emit("advance");
        })
        .catch(() => {
          this.$message.error("Erro ao enviar respostas");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss">
.survey-questions-component {
  display: flex;
  width: 100%;
  padding-top: 42px;
  align-items: center;
  flex-direction: column;

  .error {
    gap: 8px;
    padding: 8px;
    display: inline-flex;
    border-radius: 4px;
    align-items: center;
    background: $negative-024;
    border: 1px solid $negative-300;
  }
}
</style>
